module.exports = __webpack_public_path__ + "676b755b14288e4137fe987946b4ae71.jpg";